import Hero from "./Component/Hero";
import React from "react";
import KelebihanPendana from "./Component/KelebihanPendana";
import PersyaratanPendanaan from "./Component/PersyaratanPendanaan";
import DaftarPinjaman from "./Component/DaftarPinjaman";

function Pendanaan() {
    return (
        <>
            <div>
                <Hero
                    imageClass='pendanaan'
                    title='Pendanaan'
                    subTitle=''
                    explanation='
                        Anda akan mendapatkan Imbal Hasil (Bunga) yang lebih menarik dengan menjadi Pemberi Pinjaman di Danai.id, dan juga dapat memilih <u>tipe pembayaran</u> sesuai dengan kebutuhan'
                />
                <KelebihanPendana/>
                <PersyaratanPendanaan/>
                <DaftarPinjaman/>
            </div>
        </>
    );
}

export default Pendanaan;